export interface IKeywordItem {
    word: string;
    count: number;
    synonyms?: string[];
    type?: number;
}

export interface ISpeakerKeywordItem {
    speaker_id: string;
    list: IKeywordItem[];
    score: number;
}

export enum AI_KEYWORD_RULE {
    UNOPEN = 0,
    EXACT = 1,
    AI = 2,
}

// 口头禅状态 0 无口头禅 1 待计算 2 计算中 3 完成
export enum EMantraStatus {
    NONE = 0,
    PENDING = 1,
    PROCESSING = 2,
    DONE = 3,
}